export default {
  organisationUsersWithSameDomain: [],
  organisationUsers: []
}
